
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/base/Button';
import TopNavigation from '../../components/feature/TopNavigation';
import BottomNavigation from '../../components/feature/BottomNavigation';

export default function ProfilePage() {
  const navigate = useNavigate();
  const [user] = useState({
    name: 'أحمد محمد السعيد',
    phone: '+966501234567',
    email: 'ahmed@example.com',
    subscription: 'الاشتراك الشهري',
    searchesUsed: 47,
    joinDate: '2024-01-01'
  });

  const menuItems = [
    {
      icon: 'ri-user-line',
      title: 'تعديل الملف الشخصي',
      subtitle: 'تحديث المعلومات الشخصية',
      action: () => navigate('/profile/edit')
    },
    {
      icon: 'ri-history-line',
      title: 'سجل البحث',
      subtitle: 'عرض جميع عمليات البحث السابقة',
      action: () => navigate('/history')
    },
    {
      icon: 'ri-vip-crown-line',
      title: 'إدارة الاشتراك',
      subtitle: 'تفاصيل الاشتراك والفواتير',
      action: () => navigate('/payment')
    },
    {
      icon: 'ri-shield-user-line',
      title: 'إعدادات الخصوصية',
      subtitle: 'التحكم في البيانات الظاهرة',
      action: () => {}
    },
    {
      icon: 'ri-notification-line',
      title: 'الإشعارات',
      subtitle: 'إدارة التنبيهات والإشعارات',
      action: () => {}
    },
    {
      icon: 'ri-global-line',
      title: 'اللغة',
      subtitle: 'تغيير لغة التطبيق',
      action: () => navigate('/language')
    },
    {
      icon: 'ri-question-line',
      title: 'الأسئلة الشائعة',
      subtitle: 'الحصول على المساعدة',
      action: () => {}
    },
    {
      icon: 'ri-customer-service-line',
      title: 'تواصل معنا',
      subtitle: 'الدعم الفني والاستفسارات',
      action: () => {}
    }
  ];

  const handleLogout = () => {
    // Clear user data and navigate to login
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-20 font-cairo">
      <TopNavigation title="الملف الشخصي" />
      
      <div className="pt-16 px-6 py-8">
        {/* User Info Card */}
        <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
          <div className="flex items-center space-x-4 space-x-reverse mb-6">
            <div className="flex-1 text-right">
              <h2 className="text-lg font-semibold text-gray-900">{user.name}</h2>
              <p className="text-gray-600">{user.phone}</p>
              <p className="text-gray-600">{user.email}</p>
            </div>
            <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center">
              <span className="text-white text-xl font-bold">
                {user.name.split(' ')[0][0]}{user.name.split(' ')[1][0]}
              </span>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-green-50 rounded-lg p-4 text-center">
              <p className="text-sm font-medium text-green-800">{user.subscription}</p>
              <p className="text-xs text-green-600">نشط</p>
            </div>
            <div className="bg-blue-50 rounded-lg p-4 text-center">
              <p className="text-2xl font-bold text-blue-600">{user.searchesUsed}</p>
              <p className="text-sm text-blue-800">عملية بحث</p>
            </div>
          </div>
        </div>

        {/* Menu Items */}
        <div className="space-y-2">
          {menuItems.map((item, index) => (
            <button
              key={index}
              onClick={item.action}
              className="w-full bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="flex items-center space-x-4 space-x-reverse">
                <i className={`${item.icon} text-gray-600 w-5 h-5 flex items-center justify-center`}></i>
                <div className="flex-1 text-right">
                  <h3 className="font-medium text-gray-900">{item.title}</h3>
                  <p className="text-sm text-gray-600">{item.subtitle}</p>
                </div>
                <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center">
                  <i className={`${item.icon} text-gray-600 w-5 h-5 flex items-center justify-center`}></i>
                </div>
              </div>
            </button>
          ))}
        </div>

        {/* Logout Button */}
        <div className="mt-8">
          <Button
            onClick={handleLogout}
            variant="outline"
            className="w-full border-red-300 text-red-600 hover:bg-red-50"
          >
            تسجيل الخروج
          </Button>
        </div>

        {/* App Info */}
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-500">
            تطبيق سامي عبدالسلام - الإصدار 1.0.0
          </p>
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
}
